export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4670.33d64bab.jpg";